import { useState } from 'react';
import { useCreateMtoNomenclatureFromOffersMutation } from '@shared/api';
import { apiErrorMessage } from '@entities/mto';
import { Button } from '@shared/ui/Button';
import { NewItemForm, NameInput, UnitInput } from '../styles';

/** «Добавить в справочник»: наименование и единица по умолчанию — из КП,
 *  снабженец может поправить. Строки КП привязываются к новой позиции, их
 *  написания запоминаются — следующие КП с тем же текстом привяжутся сами. */
export function AddToNomenclature({
  offerIds,
  defaultName,
  defaultUnit,
  runId,
  onError,
}: {
  offerIds: string[];
  defaultName: string;
  defaultUnit: string | null;
  runId: string;
  onError: (msg: string) => void;
}) {
  const [name, setName] = useState(defaultName);
  const [unit, setUnit] = useState(defaultUnit ?? '');
  const [create, { isLoading }] = useCreateMtoNomenclatureFromOffersMutation();

  async function handleCreate() {
    if (!name.trim()) return;
    onError('');
    try {
      await create({
        runId,
        offer_ids: offerIds,
        name: name.trim(),
        unit: unit.trim() || null,
      }).unwrap();
    } catch (err) {
      onError(apiErrorMessage(err) ?? 'Не удалось добавить позицию в справочник.');
      // eslint-disable-next-line no-console
      console.error('createMtoNomenclatureFromOffers failed', err);
    }
  }

  return (
    <NewItemForm>
      <NameInput
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Наименование позиции справочника"
        aria-label="Наименование новой позиции справочника"
      />
      <UnitInput
        value={unit}
        onChange={(e) => setUnit(e.target.value)}
        placeholder="ед."
        aria-label="Единица измерения новой позиции справочника"
      />
      <Button
        type="button"
        $variant="secondary"
        onClick={handleCreate}
        disabled={!name.trim() || isLoading}
      >
        {isLoading ? 'Добавляем…' : 'Добавить в справочник'}
      </Button>
    </NewItemForm>
  );
}
